// extracted by mini-css-extract-plugin
module.exports = {"container":"MissingInstitution_container__3R9-D","header":"MissingInstitution_header__1XuKE","title":"MissingInstitution_title__2d5se","info":"MissingInstitution_info__2pxrh"};